const NotFound = () => {
	return (
		<>
			<h1 className="text-danger text-center mt-5">Not Found</h1>
		</>
	);
};

export default NotFound;
